/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_DismissInputs */

const en_toast_dismiss = /** @type {(inputs: Toast_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_toast_dismiss = /** @type {(inputs: Toast_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausblenden`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Toast_DismissInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_dismiss = /** @type {((inputs?: Toast_DismissInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_DismissInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_dismiss(inputs)
	return en_toast_dismiss(inputs)
});